import Swal from "sweetalert2";
import "./recordLoadDialog.css";

export const confirmLoadRecord = (record) => {
  const workspaceLabel = record.workspace === "exam" ? "考卷" : "講義";
  const content = document.createElement("div");
  const summary = document.createElement("div");
  summary.className = "record-load-dialog__record";

  const icon = document.createElement("span");
  icon.className = "record-load-dialog__icon";
  icon.setAttribute("aria-hidden", "true");
  icon.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6M8 13h8M8 17h5"/></svg>';

  const details = document.createElement("div");
  details.className = "record-load-dialog__details";
  const label = document.createElement("span");
  label.className = "record-load-dialog__label";
  label.textContent = "即將載入";
  const name = document.createElement("div");
  name.className = "record-load-dialog__name";
  name.textContent = record.title || `未命名${workspaceLabel}`;
  const count = document.createElement("span");
  count.className = "record-load-dialog__count";
  count.textContent = `共 ${record.question_count ?? record.items?.length ?? 0} 題`;
  details.append(label, name, count);
  summary.append(icon, details);

  const description = document.createElement("p");
  description.className = "record-load-dialog__description";
  description.textContent = "目前有尚未儲存的修改，載入後將以這份紀錄取代。";
  const reminder = document.createElement("p");
  reminder.className = "record-load-dialog__reminder";
  reminder.textContent = "若要保留目前的修改，請先取消並儲存。";
  content.append(summary, description, reminder);

  const theme = getComputedStyle(
    document.querySelector("[data-auth-theme]") || document.activeElement || document.body,
  );
  const themeValues = [
    "--app-surface", "--app-surface-text", "--app-border", "--app-subtle-text",
    "--app-input-bg", "--app-input-text", "--app-nav-active-bg", "--app-nav-active-text",
  ].map((property) => [property, theme.getPropertyValue(property).trim()]);

  return Swal.fire({
    titleText: `放棄修改並編輯這份${workspaceLabel}？`,
    html: content,
    width: "min(480px, calc(100vw - 32px))",
    customClass: {
      container: "record-load-dialog-container",
      popup: "record-load-dialog",
      title: "record-load-dialog__title",
      htmlContainer: "record-load-dialog__content",
      actions: "record-load-dialog__actions",
      confirmButton: "record-load-dialog__confirm",
      cancelButton: "record-load-dialog__cancel",
    },
    buttonsStyling: false,
    showCancelButton: true,
    reverseButtons: true,
    focusCancel: true,
    confirmButtonText: "放棄修改並開啟",
    cancelButtonText: "取消",
    didOpen: (popup) => {
      themeValues.forEach(([property, value]) => {
        if (value) popup.style.setProperty(property, value);
      });
    },
  });
};

// An opened record exports its saved layout; unsaved edits must be saved first.
export const confirmSaveBeforeExport = async () => {
  const result = await Swal.fire({
    titleText: "有尚未儲存的修改",
    text: "匯出會使用這份講義紀錄的內容。要先儲存目前的修改再匯出嗎？",
    icon: "question",
    showCancelButton: true,
    reverseButtons: true,
    confirmButtonText: "先儲存再匯出",
    cancelButtonText: "取消",
  });
  return { isConfirmed: Boolean(result?.isConfirmed) };
};
